import 'reflect-metadata';

import { ThemeProvider } from '@trackman/web-shared-components';
import Layout from 'components/Layout/Layout';
import { darkTheme, lightTheme } from 'components/Theme';
import { useStores } from 'index';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

type Props = {
  children?: React.ReactNode;
};

export const App: FC<Props> = observer((props) => {
  const ss = useStores().startupStore;
  const { darkMode } = useStores().liveDashboardStore;

  useEffect(() => {
    if (!ss.hasBearerToken && !ss.isInitializing) {
      ss.initialize();
    }
  }, [ss]);

  return (
    <ThemeProvider>
      <StyledThemeProvider theme={darkMode ? darkTheme : lightTheme}>
        <Layout>{props.children}</Layout>
      </StyledThemeProvider>
    </ThemeProvider>
  );
});

export default App;
